import * as React from "react";
const SvgFiRrBreadSlice = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17 23H7a5.006 5.006 0 0 1-5-5v-7.554a1.12 1.12 0 0 0-.391-.792A4.99 4.99 0 0 1 .066 5.179C.482 2.599 2.85.999 6.242.999h12.606a5.12 5.12 0 0 1 5.086 4.18 4.99 4.99 0 0 1-1.547 4.478 1.12 1.12 0 0 0-.387.789V18a5.006 5.006 0 0 1-5 5M6.242 3c-2.414 0-3.945.91-4.2 2.5a2.95 2.95 0 0 0 .924 2.685A3.07 3.07 0 0 1 4 10.445V18a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7.554a3.06 3.06 0 0 1 1.034-2.261 2.95 2.95 0 0 0 .925-2.685A3.106 3.106 0 0 0 18.848 3zM8 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
    />
  </svg>
);
export default SvgFiRrBreadSlice;
